import { Injectable, Injector } from "@angular/core";
import { User } from "./models/user";
import { UserAdmin } from "./models/user-admin";
import { EUserType } from "./enum/e-user-type";
import { UserCoach } from "./models/user-coach";
import { UserEleve } from "./models/user-eleve";

@Injectable({
  providedIn: 'root'
})
export class UserFactory {
    
    constructor(private injector : Injector){

    }

    create(user : User) : User {

      let obj = null;

      if(user.discriminator == EUserType.Admin){
        obj = new UserAdmin(this.injector);
      }else if(user.discriminator == EUserType.Coach){
        obj = new UserCoach(this.injector);
      }else if(user.discriminator == EUserType.Eleve){
        obj = new UserEleve(this.injector);
      }else{
          throw new Error("No user for this Type ! ");
      }
      
      return this.fillObject(obj, user);
    }

    createFromType(discriminator : EUserType) : User {

      let obj = null;

      if(discriminator == EUserType.Admin){
        obj = new UserAdmin(this.injector);
      }else if(discriminator == EUserType.Coach){
        obj = new UserCoach(this.injector);
      }else if(discriminator == EUserType.Eleve){
        obj = new UserEleve(this.injector);
      }else{
          throw new Error("No user for this Type ! ");
      }

      return obj;
    }

  private fillObject(user : User, object : any){
      
      for (const [key, value] of Object.entries(object)) {
          if(user.hasOwnProperty(key)){
            user[key] = value;
          }
      }
      return user;
  }
}

